import React from 'react';
import { match } from 'ts-pattern';
import { getAssetPath } from 'utils/asset-utils';
import { RegionInfoFragment } from 'utils/gqlReactTypings.generated.d';

const getMetroSvg = (regionName: string): string => {
  return match(regionName)
    .with('BAY_AREA', () => getAssetPath('/images/metro-icon-bay-area.svg'))
    .with('CHICAGO', () => getAssetPath('/images/metro-icon-chicago.svg'))
    .with('LOS_ANGELES', () => getAssetPath('/images/metro-icon-los-angeles.svg'))
    .with('NEW_YORK', () => getAssetPath('/images/metro-icon-new-york.svg'))
    .with('SEATTLE', () => getAssetPath('/images/metro-icon-seattle.svg'))
    .otherwise(() => getAssetPath('/images/metro-icon-default.svg'));
};

interface IProps {
  region: RegionInfoFragment;
  className?: string;
}

export const MetroImage: React.FC<IProps> = ({ className, region }) => {
  const svgPath = getMetroSvg(region.name);
  if (!svgPath) return null;

  return <img src={svgPath} alt={region.displayName} className={`h-[104px] w-[104px] ${className}`} />;
};
